export default {
    android : {
        link: "https://play.google.com/store/apps/details?id=com.tosfabredev.gardepharma"
    }
}

